/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationsVerifyOnboardingHooksSetup } from "../funcs/organizationsVerifyOnboardingHooksSetup.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { VerifyOnboardingHooksSetupResult } from "../models/components/verifyonboardinghookssetupresult.js";
import {
  VerifyOnboardingHooksSetupRequest,
  VerifyOnboardingHooksSetupSecurity,
} from "../models/operations/verifyonboardinghookssetup.js";
import { unwrapAsync } from "../types/fp.js";
export type VerifyOnboardingHooksSetupQueryData =
  VerifyOnboardingHooksSetupResult;

export function prefetchVerifyOnboardingHooksSetup(
  queryClient: QueryClient,
  client$: GramCore,
  request?: VerifyOnboardingHooksSetupRequest | undefined,
  security?: VerifyOnboardingHooksSetupSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildVerifyOnboardingHooksSetupQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildVerifyOnboardingHooksSetupQuery(
  client$: GramCore,
  request?: VerifyOnboardingHooksSetupRequest | undefined,
  security?: VerifyOnboardingHooksSetupSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<VerifyOnboardingHooksSetupQueryData>;
} {
  return {
    queryKey: queryKeyVerifyOnboardingHooksSetup({
      sinceUnixNano: request?.sinceUnixNano,
      gramSession: request?.gramSession,
    }),
    queryFn: async function verifyOnboardingHooksSetupQueryFn(
      ctx,
    ): Promise<VerifyOnboardingHooksSetupQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationsVerifyOnboardingHooksSetup(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyVerifyOnboardingHooksSetup(
  parameters: {
    sinceUnixNano?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizations",
    "verifyOnboardingHooksSetup",
    parameters,
  ];
}
